module.exports = __webpack_public_path__ + "static/media/icon-alert-white.d071b8a9.svg";